import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { LoadingSpinnerComponent } from '@components/loading/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-icon-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    RouterLink,
    LoadingSpinnerComponent,
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
})
export class IconButtonComponent {
  Icon = input.required<string>();
  Link = input<string>();
  IsInSite = input(true);
  IsFillIcon = input(false);
  Appearance = input<'primary' | 'secondary' | 'accent' | 'default'>('primary');
  disabled = input(false);
  loading = input(false);
  IsButton = input(false);
  WithTooltip = input(false);
  TooltipText = input<string>();
  click = output();
}
